/** Match iOS PropertyProfileView.normalizeAddress */
function normalizeAddress(address: string): string {
  return address
    .replace(/,/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .join(' ')
    .trim()
}

const STREET_ABBREVIATIONS: Record<string, string> = {
  road: 'rd',
  street: 'st',
  lane: 'lane',
  avenue: 'ave',
  drive: 'dr',
  court: 'ct',
  crescent: 'cres',
  place: 'pl',
  terrace: 'tce',
  grove: 'gr',
}

/**
 * realestate.com.au property URL — same slug rules as iOS.
 * e.g. "136 DAVID HILL ROAD, MONBULK VIC 3793"
 *   → https://www.realestate.com.au/property/136-david-hill-rd-monbulk-vic-3793/
 */
export function realestateListingUrl(fullAddress: string): string | null {
  if (!fullAddress.trim()) return null
  let normalized = normalizeAddress(fullAddress).toLowerCase()
  const hasSlash = normalized.includes('/')
  normalized = normalized.replace(/\//g, '-')
  const words = normalized.split(/\s+/).filter(Boolean).map((w) => STREET_ABBREVIATIONS[w] ?? w)
  if (hasSlash) words.unshift('unit')
  const slug = words.join('-')
  if (!slug) return null
  return `https://www.realestate.com.au/property/${slug}/`
}

/**
 * Domain property-profile URL — same slug rules as iOS.
 * e.g. "136 DAVID HILL ROAD, MONBULK VIC 3793"
 *   → https://www.domain.com.au/property-profile/136-david-hill-road-monbulk-vic-3793
 */
export function domainListingUrl(fullAddress: string): string | null {
  if (!fullAddress.trim()) return null
  let normalized = normalizeAddress(fullAddress).toLowerCase()
  normalized = normalized.replace(/\//g, '-').replace(/\s+/g, '-')
  while (normalized.includes('--')) {
    normalized = normalized.replace(/--/g, '-')
  }
  if (!normalized) return null
  return `https://www.domain.com.au/property-profile/${normalized}`
}
